"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProfileGuard = void 0;
var tslib_1 = require("tslib");
var user_data_response_validator_1 = require("../../../utils/user-data-response-validator");
var getProfileGuard = function (requestRoute, requestedProfileId) { return function (response) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var hasRequiredData, validationCallback;
    var _a;
    return tslib_1.__generator(this, function (_b) {
        hasRequiredData = Boolean(requestedProfileId) && Boolean((_a = response === null || response === void 0 ? void 0 : response.profile) === null || _a === void 0 ? void 0 : _a.id);
        if (!hasRequiredData) {
            return [2 /*return*/, response];
        }
        validationCallback = function () { return requestedProfileId === response.profile.id; };
        return [2 /*return*/, user_data_response_validator_1.userDataResponseValidator.validateResponse({
                response: response,
                validationCallback: validationCallback,
                reportingData: {
                    endpointUri: requestRoute,
                    message: "Profile Details response is invalid for ".concat(requestedProfileId, " compared with remote ").concat(response.profile.id),
                    requestData: "profileId: ".concat(requestedProfileId),
                    responseData: "profileId: ".concat(response.profile.id),
                },
            })];
    });
}); }; };
exports.getProfileGuard = getProfileGuard;
